import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["disabled", "title", "aria-label", "textContent"];
const _hoisted_2 = ["disabled", "title", "aria-label", "textContent"];
import { computed, inject } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectAllLinks',
    props: {
        selectAllVisible: { type: Boolean, default: false },
        unselectAllVisible: { type: Boolean, default: false },
        selectAllText: { default: () => inject("i18n").t("Select All") },
        unselectAllText: { default: () => inject("i18n").t("Deselect All") },
        disabled: { type: Boolean, default: false }
    },
    emits: ["selectAll", "unselectAll"],
    setup(__props, { emit: __emit }) {
        /********************************************
         * SelectAllLinks Component
         *
         * Renders "Select All" and "Unselect All" links
         * with animated visibility transitions.
         * Designed for use in multiselect contexts.
         *
         *********************************************/
        const props = __props;
        const emit = __emit;
        const isVisible = computed(() => !props.disabled && (props.selectAllVisible || props.unselectAllVisible));
        const onSelectAll = () => {
            if (props.disabled)
                return;
            emit("selectAll");
        };
        const onUnselectAll = () => {
            if (props.disabled)
                return;
            emit("unselectAll");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['select-all-links', { 'select-all-links--visible': isVisible.value }])
            }, [
                (__props.selectAllVisible)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        disabled: __props.disabled,
                        title: __props.selectAllText,
                        "aria-label": __props.selectAllText,
                        onClick: onSelectAll,
                        textContent: _toDisplayString(__props.selectAllText)
                    }, null, 8, _hoisted_1))
                    : _createCommentVNode("", true),
                (__props.unselectAllVisible)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        disabled: __props.disabled,
                        title: __props.unselectAllText,
                        "aria-label": __props.unselectAllText,
                        onClick: onUnselectAll,
                        textContent: _toDisplayString(__props.unselectAllText)
                    }, null, 8, _hoisted_2))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
